export class Option<T> {
  value: T;
  text: string;
  subtext?: string;
  description?: string;
  exclusive?: boolean;
}
